import { APP_INITIALIZER, NgModule } from '@angular/core'
import { PageModule } from './page/page.module'
import { CmsPageGuard } from '@spartacus/storefront'
import { CmsPageHiddenGuard } from './guards/cms-page-hidden.guard'
import { ExternalRoutesGuard } from '@spartacus/core'
import { SafeHtmlModule } from './pipes/sanitize-html/safe-html.module'
import { RedirectGuard } from './guards/redirect.guard'
import { MovingImageModule } from './services/moving-image/moving-image.module'
import { MbNavigationModule } from './navigation/mb-navigation.module'
import { FooterModule } from './footer/footer.module'
import { MbBreadcrumbModule } from './breadcrumb/mb-breadcrumb.module'
import { CmsConfigModule } from './cms-config.module'
import { CmsDirectivesModule } from './directives/cms-directives.module'
import { CountryBarService } from './services/country-bar/country-bar.service'
import { MbWebformsModule } from './services/mb-webforms/mb-webforms.module'
import { CmsPageTypeService } from './services/cms-page-type/cms-page-type.service'
import { GotoRedirectService } from './services/goto-redirect/goto-redirect.service'
import { ChatBotModule } from './services/chat-bot/chat-bot.module'
import { CmsComponentsModule } from './components/cms-components.module'
import { UcModule } from './services/usercentrics-consent-manager/uc.module'
import { HttpRequestInterceptorModule } from './services/http-request-interceptor/http-request-interceptor.module'
import { CommonModule } from '@angular/common'

@NgModule({
  imports: [
    PageModule,
    CmsComponentsModule,
    MovingImageModule,
    SafeHtmlModule,
    MbNavigationModule,
    FooterModule,
    MbBreadcrumbModule,
    CmsConfigModule,
    CmsDirectivesModule,
    MbWebformsModule,
    ChatBotModule,
    UcModule,
    HttpRequestInterceptorModule,
    CommonModule
  ],
  providers: [
    { provide: CmsPageGuard, useExisting: CmsPageHiddenGuard },
    { provide: ExternalRoutesGuard, useExisting: RedirectGuard },
    {
      provide: APP_INITIALIZER,
      useFactory: (countryBarService: CountryBarService) => () => countryBarService.init(),
      deps: [CountryBarService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (cmsPageTypeService: CmsPageTypeService) => () => cmsPageTypeService.init(),
      deps: [CmsPageTypeService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (gotoRedirectService: GotoRedirectService) => () => gotoRedirectService.init(),
      deps: [GotoRedirectService],
      multi: true
    }
  ]
})
export class CmsModule {
}

